import { connect } from 'react-redux';
import PresentationComponent from 'src/ui/features/Login/presentational';
import {
  login,
  forgotPassword,
  returnToLogin,
  setPINCode,
  gotoPage,
  resendCodePending,
  resetPasswordPending,
} from 'src/ui/features/Login/state/loginActions';
import { getUserIsLocked } from 'src/ui/features/Login/state/loginReselect';
import { TFAPAGE, FPASSPAGE, RPASSPAGE } from 'src/ui/features/Login/state/constants';
import { logoutSession } from 'src/ui/features/Login/state/loginActions';

const mapStateToProps = state => {
  const {
    error,
    forgotPasswordStatus,
    loginStatus,
    numberAttempts,
    email,
    userSuccess,
    profileKey,
    token,
    loginPage,
    validateCodeStatus,
    resendCodeMessage,
  } = state.login;

  const isUserLocked = getUserIsLocked(state);
  return {
    error,
    loginStatus,
    validateCodeStatus,
    forgotPasswordStatus,
    numberAttempts,
    userSuccess,
    profileKey,
    token,
    isUserLocked,
    loginPage,
    email,
    resendCodeMessage,
  };
};

const mapDispatchToProps = {
  login,
  forgotPassword,
  returnToLogin,
  setPINCode,
  gotoPage,
  logoutSession,
  resendCode: resendCodePending,
  resetPasswordPending,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { loginPage } = stateProps;
  const { forgotPassword, setPINCode, login, resetPasswordPending, ...otherDispatchers } = dispatchProps;
  let onClickAction = null;
  switch (loginPage) {
    case FPASSPAGE:
      onClickAction = forgotPassword;
      break;
    case TFAPAGE:
      onClickAction = setPINCode;
      break;
    case RPASSPAGE:
      onClickAction = resetPasswordPending;
      break;
    default:
      onClickAction = login;
  }
  return {
    ...stateProps,
    ...otherDispatchers,
    ...ownProps,
    onClick: onClickAction,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(PresentationComponent);



// WEBPACK FOOTER //
// ./src/ui/features/Login/containers/LoginContainer.js